const initialState = {
  eventType: 'all',
  allEvents: [],
};

export default (state = initialState, action) => {
  const { type, data } = action;

  switch (type) {
  case 'ALL_EVENTS:SET':
    return {
      ...state,
      allEvents: data,
    };
  default:
    return state;
  }
};
